import React, { useContext, useEffect, useRef } from "react";
import styles from "./StickyEvnegia.module.scss";
import StickyContext from "../../context/sticky";
import PathContext from "../../context/path";
import { useState } from 'react';
const StickyEvnegia = (props) => {
  const progress = useContext(StickyContext);
  const path = useContext(PathContext);
  const refInner = useRef(null);
  const refBody = useRef(null);
  const [marked, setMarked] = useState(false);
  useEffect(() => {
    const inner = refInner.current;
    const body = refBody.current;
    let innerHeight = inner.offsetHeight;
    let bodyHeight = body.offsetHeight;
    let top = (innerHeight - bodyHeight) * progress / 100;
    inner.style.top = -top + 'px';
    if(progress >= 33){
      setMarked(true);
    }else{
      setMarked(false);
    } 
  }, [progress]);
  let quoteClass = `${styles.quote}`;
  if(marked){
    quoteClass = `${styles.quote} ${styles.marked}`;
  }
  return (
    <>
      <div className={styles.wrap}>
        <div className={styles.body} ref={refBody} data-animate={'fade-in-left'}>
          <div className={quoteClass}>
          Первый, <span>лучший, самый эффективный</span> препарат
          </div>
          <div className={styles.inner} ref={refInner}>
            <div className={styles.item}>
              <div className={styles.item__label}>
                <div className={styles.item__img}>
                  <img src={`${path}/img/chat-placeholder-green.webp`} alt="" />
                </div>
                <div className={styles.item__name}>
                  <span>Денис,</span> маркетолог
                </div>
              </div>
              <div className={styles.item__text}>
                Привет, можешь посмотреть формулировки с юридической точки зрения? Источники к материалу прилагаю во вложении.
              </div>
            </div>
            <div className={styles.item}>
              <div className={styles.item__label}>
                <div className={styles.item__img}>
                  <img src={`${path}/img/chat-placeholder-pink-2.webp`} alt="" />
                </div>
                <div className={styles.item__name}>
                  <span>Елена,</span> юрист
                </div>
              </div>
              <div className={styles.item__text}>
              Привет! Первый — допустимо, у нас есть все документальные подтверждения. А вот лучший и самый эффективный нужно скорректировать. Может, попробуем «Первый препарат с доказанной эффективностью»?
              </div>
            </div>
            <div className={styles.item}>
              <div className={styles.item__label}>
                <div className={styles.item__img}>
                  <img src={`${path}/img/chat-placeholder-green.webp`} alt="" />
                </div>
                <div className={styles.item__name}>
                  <span>Денис,</span> маркетолог
                </div>
              </div>
              <div className={styles.item__text}>
              Спасибо, по смыслу хорошо! Я еще обсужу с этикой и вернусь.
              </div>
            </div>

          </div>
        </div>
      </div>
    </>
  );

}

export default StickyEvnegia;
